import ReactiveComponent from '@utils/reactive-component';
import parseRenderingContext from '@utils/parse-rendering-context';
import CartSummary from '../cart-landing/cart-summary';
import template from './templates/checkout-summary';
import { context as defaultContext } from './checkout-defaults';
import store from '@stores/cart/cart-store';

export default class CheckoutSummary extends CartSummary.extendTemplate(template) {
    constructor($originEl, context) {
        context = { ...defaultContext, ...context };

        super($originEl, context);

        this.reactive = new ReactiveComponent({
            state: {
                checkoutLoading: false,
                loading: false
            }
        });

        this.context = context;
    }

    setupListeners() {
        this.reactive.watch('checkoutLoading', (checkoutLoading) => this.checkoutLoader.active = checkoutLoading);

        store.watch('loading', (...[, , loading]) => {
            if (loading) {
                this.showLoading();
            } else {
                this.hideLoading();
            }
        });
    }

    hideLoading() {
        this.loaders.forEach(loader => (loader.active = false));

        this.renderTotals();
    }

    renderTotals() {
        this.$discounts.html(store.getters.formattedDiscount);
        this.$shipping.html(store.getters.formattedShippingTotal);
        this.$subtotal.html(store.getters.formattedSubtotal);
        this.$tax.html(store.getters.formattedTaxTotal);
        this.$total.html(store.getters.formattedTotal);
    }

    showLoading() {        
        this.$discounts.empty();
        this.$shipping.empty();
        this.$subtotal.empty();
        this.$tax.empty();
        this.$total.empty();

        this.loaders.forEach(loader => (loader.active = true));
    }
}

$(() => {
    const rootEls = document.querySelectorAll('.js-checkout-summary');
    rootEls.forEach((el) => {
        const $el = $(el);
        const renderingContext = parseRenderingContext(el);

        const summary = new CheckoutSummary($el, renderingContext);
        summary.init();

        summary.showLoading();
        const unwatch = store.watch('loaded', (...[, , loaded]) => {
            if (loaded) {
                unwatch();
            }
        });
    });
});
